// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/views/partner/crud/customerDetails/index.css
// module id = 1937
// module chunks = 0